"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheUnaryFunction = void 0;
/**
 *  @since 0.0.1
 */
function cacheUnaryFunction(f) {
    var mapping = new Map();
    var fres = function (key) {
        var res = mapping.get(key);
        if (res !== undefined) {
            return res;
        }
        else {
            var v = f(key);
            mapping.set(key, v);
            return v;
        }
    };
    return fres;
}
exports.cacheUnaryFunction = cacheUnaryFunction;
